import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useUserSelector } from '~/hooks/useUserSelector';
import {
  fireWorkerTypePopupConfirmed,
  fireWorkerTypePopupViewed,
} from '~/posthogs/events/Signup';
import { routes } from '~/routes';
import { useIsWorkerClassificationEnabled } from '~/selectors';
import { useRequireSignUpStep } from '../shared/useRequireSignUpStep';
import { SignUpStepWrapper } from '../shared/SignUpStepWrapper';
import { OfficeSetupForm } from './OfficeSetupForm';
import { OneMoreStepPopup } from './OneMoreStepPopup';
import { IUserLike } from './types';
import { useOfficeSetupCopy } from './useOfficeSetupCopy';

export const OfficeSetupPage = () => {
  useRequireSignUpStep();

  const navigate = useNavigate();
  const user = useUserSelector() as IUserLike | null | undefined;
  const officeState = user?.address?.[0]?.state ?? '';

  const { title, subtitle } = useOfficeSetupCopy();

  const isDualModelState = Boolean(useIsWorkerClassificationEnabled());
  const [showOneMoreStep, setShowOneMoreStep] = useState(false);

  return (
    <SignUpStepWrapper
      step={3}
      backTo={routes.signUpRedesign.officeDetails}
      title={title}
      subtitle={subtitle}
    >
      <OfficeSetupForm
        isProfileComplete={!isDualModelState}
        onSuccess={() => {
          if (isDualModelState) {
            if (officeState) {
              fireWorkerTypePopupViewed();
              setShowOneMoreStep(true);
            } else {
              navigate(routes.signUpRedesign.workerType);
            }
            return;
          }
          navigate('/dashboard');
        }}
      />
      <OneMoreStepPopup
        open={showOneMoreStep}
        state={officeState}
        onReview={() => {
          fireWorkerTypePopupConfirmed();
          navigate(routes.signUpRedesign.workerType);
        }}
      />
    </SignUpStepWrapper>
  );
};
